import { render, staticRenderFns } from "./AddEventDirector.vue?vue&type=template&id=4b518956"
import script from "./AddEventDirector.vue?vue&type=script&lang=js"
export * from "./AddEventDirector.vue?vue&type=script&lang=js"
import style0 from "./AddEventDirector.vue?vue&type=style&index=0&id=4b518956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports